<template>
  <div class="center-page">
    <section class="band">
      <div class="container">
        <div class="center-grid">
          <!-- 左侧菜单：handoff 白底卡片 + 蓝色激活态（替换旧 leftAside/*.png 图标） -->
          <aside class="center-nav">
            <div class="center-nav-head">个人中心</div>
            <router-link
              v-for="item in caselist"
              :key="item.url"
              :to="item.url"
              class="center-nav-item"
              @click.native="listChange(item.index)"
            >
              <span class="center-nav-ico" v-html="item.icon"></span>
              <span>{{ item.name }}</span>
            </router-link>
          </aside>

          <div class="center-main">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* 个人中心外壳：左侧菜单 + 子路由内容。
   五个子页面的路由、接口调用与业务逻辑保持不变；仅替换菜单视觉与图标。 */
const ICON = {
  dashboard:
    '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8" ' +
    'stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7.5" height="7.5" rx="2"/>' +
    '<rect x="13.5" y="3" width="7.5" height="7.5" rx="2"/><rect x="3" y="13.5" width="7.5" height="7.5" rx="2"/>' +
    '<rect x="13.5" y="13.5" width="7.5" height="7.5" rx="2"/></svg>',
  cert:
    '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8" ' +
    'stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.6l7.2 2.7v6c0 4.6-3.1 8.3-7.2 10.2-4.1-1.9-7.2-5.6-7.2-10.2v-6z"/>' +
    '<path d="M8.8 11.9l2.3 2.3 4.1-4.4"/></svg>',
  api:
    '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8" ' +
    'stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="6" rx="2"/>' +
    '<rect x="3" y="14" width="18" height="6" rx="2"/><path d="M7 7h.01M7 17h.01"/></svg>',
  bill:
    '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8" ' +
    'stroke-linecap="round" stroke-linejoin="round"><path d="M3 20h18M6.5 20V10M12 20V4M17.5 20v-7"/></svg>',
  order:
    '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8" ' +
    'stroke-linecap="round" stroke-linejoin="round"><path d="M6 2.8h12v18.4l-3-1.8-3 1.8-3-1.8-3 1.8z"/>' +
    '<path d="M9 8h6M9 12h6"/></svg>'
}

export default {
  name: 'center',
  data() {
    return {
      caselist: [
        { name: '控制台', url: '/center/case1', index: 0, icon: ICON.dashboard },
        { name: '企业认证', url: '/center/case2', index: 1, icon: ICON.cert },
        { name: '我的接口', url: '/center/case3', index: 2, icon: ICON.api },
        { name: '接口账单', url: '/center/case4', index: 3, icon: ICON.bill },
        { name: '我的订单', url: '/center/case5', index: 4, icon: ICON.order }
      ]
    }
  },
  methods: {
    // 子页面仍按旧约定提交 setCenterIndex，这里同步一次保持 store 状态一致
    listChange(index) {
      this.$store.commit('setCenterIndex', index)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/center/index.vue